import {getAppConfigRequestKeys} from '../../appConfig/getAppConfigRequestKeys';
import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {AppConfigKeyValueMapVo} from '../../common/shared/api/nicolas/vo/AppConfigKeyValueMapVo.interface';
import {AppConfigKeyVo} from '../../common/shared/api/nicolas/vo/enums/AppConfigKeyVo.enum';

/**
 * 취향 서비스 언어 설정 조회
 *
 * Origin: pageNicolasApi.getTastesServiceLang
 * API: GET /api/v1/app/setting
 */
export async function getAppSettingTastesServiceLang(
  options?: FetcherOptions
): Promise<ApiResultVo & AppConfigKeyValueMapVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/app/setting',
    {
      method: 'GET',
      params: {
        keys: getAppConfigRequestKeys([AppConfigKeyVo.TastesServiceLang]),
      },
    },
    options
  );
  return response.data;
}
